import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { UiButton } from 'src/components/UI/Button';
import { UiOuterLink } from 'src/components/UI/OuterLink';
import { signInOutSlice } from 'src/pages/Account/Profile/Signin/store/slice';
import { ROUTE_SIGNIN_PATH } from 'src/routes';
import { commonCurrentPartnerSelector } from 'src/store/commonPart/selector';
import { addReturnUrl } from 'src/utils/url';

type Props = {
  partnerName: string | null;
  onClose: () => void;
};

export const HeaderUserSigninPopupComponent: React.FC<Props> = ({ partnerName, onClose }: Props) => {
  const { response } = useSelector(commonCurrentPartnerSelector);

  const dispatch = useDispatch();

  const { t } = useTranslation();
  const signInLong = t('header.account.signInOffer', { partnerName: partnerName || '' });

  const { pathname } = useLocation();

  const signInText = t('header.account.signInAction');

  return (
    <div id="userSigninPopup" className="popover-content">
      <div className="row">
        <div className="col-xs-12 popover-user-email">{signInLong}</div>
      </div>
      <div className="row">
        <div className="col-xs-12 popover-user-sign-out">
          {response?.IsSsoEnabled ? (
            <UiOuterLink
              href={addReturnUrl('/account/logindispatcher', pathname)}
              className="btn-flat waves-effect pull-right link-like no-box-shadow text-uppercase"
            >
              {signInText}
            </UiOuterLink>
          ) : (
            <UiButton
              tag="a"
              className="btn-flat waves-effect pull-right link-like no-box-shadow text-uppercase"
              onClick={() => {
                if (pathname !== ROUTE_SIGNIN_PATH) {
                  dispatch(signInOutSlice.actions.changeModal(true));
                }
                onClose();
              }}
            >
              {signInText}
            </UiButton>
          )}
        </div>
      </div>
    </div>
  );
};
